import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=3b7fcd66&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=3b7fcd66&lang=scss"
import style1 from "./Information.vue?vue&type=style&index=1&id=3b7fcd66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7fcd66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7fcd66')) {
      api.createRecord('3b7fcd66', component.options)
    } else {
      api.reload('3b7fcd66', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=3b7fcd66&scoped=true", function () {
      api.rerender('3b7fcd66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/Information.vue"
export default component.exports